<template>
  <el-upload
    class="upload-demo"
    name="document"
    :multiple="multiple"
    :action="uploadApi"
    :headers="headers"
    :on-preview="handlePreview"
    :on-remove="handleRemove"
    :on-exceed="handleExceed"
    :on-change="handleChange"
    :on-success="handleUpload"
    :list-type="listType"
    :thumbnail-mode="thumbnail"
    :accept="accept"
    :file-list="fileList">
    <el-button size="small" type="primary">{{ buttonText }}</el-button>
    <div v-if="!noTip" slot="tip" class="el-upload__tip">Upload to RS backend documents</div>
  </el-upload>
</template>

<script>
import { UPLOAD_API } from '../env';

export default {
  name: 'Uploader',
  props: {
    listType: { type: String, default: 'text' },
    list: { type: Array, default: () => [] },
    multiple: { type: Boolean, default: false },
    warn: { type: Boolean, default: false },
    pdf: { type: Boolean, default: false },
    noTip: { type: Boolean, default: false },
    uploadPrefix: { type: String, required: false },
    thumbnail: { type: Boolean, default: false },
    buttonText: { type: String, default: 'Click to upload' },
  },
  data() {
    return {
      uploadApi: this.uploadPrefix ? `${UPLOAD_API}/${this.uploadPrefix}` : UPLOAD_API,
      fileList: this.list,
    };
  },
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${this.$keycloak.token}`,
      };
    },
    accept() {
      if (this.listType === 'picture') {
        return 'image/png, image/jpeg, image/jpg';
      }
      if (this.pdf) {
        return 'application/pdf';
      }

      return '';
    },
  },
  methods: {
    handleChange(file, fileList) {
      if (this.multiple) {
        this.fileList = fileList;
      } else {
        this.fileList = [file];
      }
    },
    handleRemove(file, fileList) {
      this.fileList = fileList;
      this.$emit('remove-upload', file.url);
      this.$emit('update-list', fileList);
    },
    handlePreview(file) {
      console.log(file);
      console.log(file.response.url);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`The limit is 3, you selected ${files.length} files this time, add up to ${files.length + fileList.length} totally`);
    },
    beforeRemove(file, fileList) {
      this.$emit('remove-upload', file.url);
      // return this.$confirm(`Cancel the transfer of ${file.name} ?`);
    },
    handleUpload(response, file, fileList) {
      this.fileList = [file];
      if (this.warn) {
        this.$message({
          message: 'Upload will be overwritten with the previous one.',
          center: true,
        });
      }
      this.$emit('upload-completed', response.url);
      this.$emit('upload-file', file);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue